import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { FiSettings } from 'react-icons/fi'
import { Tooltip } from '@chakra-ui/react'
import { Box, Center } from '@chakra-ui/react'

import { useTeamChatConversation } from '../../provider'
import SharedStack from '~components/shared/wrappers/shared-stack'
import { InternalChatUsersPreview } from '~components/team-chat/user-avatar'

interface Props {
    onOpen: () => void
}

export default function TeamChatUsersButton({ onOpen }: Props) {
    const { internalChatUsers } = useTeamChatConversation()

    return (
        <Tooltip label="Manage team chat" placement="start" hasArrow>
            <Box
                p={1.5}
                rounded="lg"
                bg="transparent"
                _hover={{ bg: 'gray.100' }}
                cursor="pointer"
                onClick={onOpen}
            >
                <SharedStack row fit>
                    <InternalChatUsersPreview users={internalChatUsers} />
                    <Center w="24px" h="24px">
                        <Icon as={FiSettings} fontSize="sm" color="gray.800" />
                    </Center>
                </SharedStack>
            </Box>
        </Tooltip>
    )
}
